export default __webpack_public_path__ + "static/media/left_arrow.386bc369.svg";